var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mall-select',{attrs:{"need-all":true},on:{"change":_vm.setEntryContractContentByMallConfiguration},model:{value:(_vm.selectedMallNoSync),callback:function ($$v) {_vm.selectedMallNoSync=$$v},expression:"selectedMallNoSync"}})}
var staticRenderFns = []

export { render, staticRenderFns }